import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import SupermarketTabs from "../components/SupermarketTabs";
import ProductSection from "../components/ProductSection";
import Footer from "../components/Footer";
import productsData from "../data/mydata.json";

const sections = [
  "Today's Top Deals",
  "Features Products",
  "Tesco Products",
  "Morrisons Products",
  "ASDA Products",
  "Sainsbury's Products",
];

function FemtyzHome({ onOpenAuth, onOpenMenu }) {
  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto flex max-w-8xl gap-6 px-4 py-6 md:px-6">
        <Sidebar />

        <section className="flex-1 space-y-8">
          <SupermarketTabs />

          {sections.map((section, idx) => (
           <ProductSection
           key={section}
           title={section}
           sectionIdx={idx}
           products={productsData}
         />
          ))}
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default FemtyzHome;